//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'
import { Provider } from 'react-redux'

import './index.css'

import { ThemeProvider, Typography } from '@mui/material'
import CssBaseLine from '@mui/material/CssBaseline'
import { theme } from './components/theme'
import { StrictMode } from 'react'

import { createRoot } from 'react-dom/client'

import { AlertWrapper } from './components/alerts/AlertWrapper'
import { setupStoreWithInitialStateWithChainConnection } from '@react/redux/store'

import { WebsocketProvider } from '@react/components/WebSocketProvider'

import { AppForLocation } from './components/AppForLocation'
import { AppKitListener } from './components/AppKitListener'
import Footer from './components/Footer'

// const reactVar = process.env.REACT_APP_VARIABLES as Record<string, string>
// Object.keys(reactVar).forEach((key) => {
//   process.env[key] = reactVar[key]
// })

const root = createRoot(document.getElementById('root') as HTMLElement)

const isLocalHost = location.hostname === 'localhost'

setupStoreWithInitialStateWithChainConnection().then((initializedStore) => {
  console.log('setupStoreWithInitialStateWithChainConnection6', initializedStore.getState().chainState.userConnection)
  root.render(
    <StrictMode>
      <div
        className="app-container"
        style={{
          height: '100%',
          minHeight: '100vh',
          backgroundColor: theme.palette.background.canvas,
        }}
      >
        <ThemeProvider theme={theme}>
          <CssBaseLine />
          <Provider store={initializedStore}>
            <AlertWrapper>
              {/* <Typography variant="h1">OpenTrade upgrade in progress...</Typography>
              <Typography variant="h1">It will take a few minutes to complete.</Typography> */}
              <WebsocketProvider>
                <AppForLocation />
                {!isLocalHost && <AppKitListener />}
              </WebsocketProvider>
            </AlertWrapper>
          </Provider>
          <Footer />
        </ThemeProvider>
      </div>
    </StrictMode>
  )
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logOT.debug))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals()
